// Layout Shell - Renders Header and Sidebar outside of Router flow
// This prevents them from re-rendering on route changes
import { memo } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { SidebarProvider } from './SidebarContext';
import { LocationProvider } from './LocationContext';
import { MiniPlayer } from '@components/audio/MiniPlayer';

// Memoized wrapper to prevent re-renders
const SidebarProviderWrapper = memo(({ children }: { children: React.ReactNode }) => {
  return <SidebarProvider>{children}</SidebarProvider>;
});
SidebarProviderWrapper.displayName = 'SidebarProviderWrapper';

// Layout Shell - Only renders Header and Sidebar, never re-renders on route changes
// Rendered outside Router flow to prevent re-renders on route changes
export const LayoutShell: React.FC = memo(() => {
  return (
    <SidebarProviderWrapper>
      <LocationProvider>
        {/* Header and Sidebar - rendered outside Router flow, never re-render on route changes */}
        <Sidebar />
        <Header />
        
        {/* Mini Player - Always visible at bottom */}
        <MiniPlayer />
      </LocationProvider>
    </SidebarProviderWrapper>
  );
});
LayoutShell.displayName = 'LayoutShell';

